


$('.js-open-close-menu').click(function(){
  $(this).toggleClass('open')
  $(this).parent().toggleClass('open')
  $('header').toggleClass('show')
  $('html').toggleClass('modal-open')
  $('.js-phone-nav').fadeToggle();
  $('.js-tablet-menu-bg').fadeToggle()
})


//-- Show Hide on Scroll ---

let doc = document.documentElement;
let w = window;

let prevScroll = w.scrollY || doc.scrollTop;
let curScroll;
let direction = 0;
let prevDirection = 0;

let header = document.querySelector('header');

let checkScroll = function() {

  curScroll = w.scrollY || doc.scrollTop;
  if (curScroll > prevScroll) {
    //scrolled up
    direction = 2;
  }
  else if (curScroll < prevScroll) {
    //scrolled down
    direction = 1;
  }

  //if (direction !== prevDirection) {
    toggleHeader(direction, curScroll);
  //}

  prevScroll = curScroll;
};

let toggleHeader = function(direction, curScroll) {
  //if (curScroll > window.outerHeight || $('.on-video-container').css('display') === 'none') {
    if (direction === 2 && curScroll > 95) {
      header.classList.add('hide');
    } else if (direction === 1) {
      header.classList.remove('hide');
    }
  // } else {
  //   header.classList.add('hide');
  // }
  prevDirection = direction;
};

window.addEventListener('scroll', checkScroll);

// -- End show hide scroll --
